@import "tailwindcss";

@theme {
  --font-sans: "Inter", "sans-serif";
}

@layer base {
  body {
    @apply bg-slate-50 text-slate-900 font-sans antialiased;
  }
}